import {fnToastrFormError, printResponse} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnDisplayEmployeeChanges = function () {

    var tableName = '#datatable-customer-employees';

    if (!element_exists(tableName)) return false;

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

    $(document).off('click', '.btn-delete-employee');
    $(document).on('click', '.btn-delete-employee', function (e) {
        e.preventDefault();

        var validation =  allLangFiles.employee.validation;

        var btnSelf = this;

        $.confirm({
            title: validation.are_you_sure,
            content: validation.delete_employee_confirm_text,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {
                        $.ajax({
                            url: $(btnSelf).data('href'),
                            method: 'DELETE',
                            success: function (response) {
                                $(tableName).DataTable().ajax.reload(null, false);
                                toastr.success('Deleted employee');
                            },
                            error: function (error) {
                                if(error.status === 403){
                                    fnToastrFormError(error);
                                    return;
                                }
                                toastr.error(error)
                            }
                        });
                    },
                    text: validation.yes
                },
                Nej: {
                    text: validation.no
                },
            }
        });
    });

    $(document).off('click', '.btn-display-employee-changes');
    $(document).on('click', '.btn-display-employee-changes', function (e) {
        e.preventDefault();

        var url = $(this).attr('data-href');

        var modalName = '#modal-note-employee-changes';

        if (!element_exists(modalName)) {

            $.ajax({
                url: url,
                success: function (response) {

                    $('.dynamic-modal-container').append(response);

                    var modal = $(modalName);

                    modal.modal('show');

                    var form = $('#form-note-employee-changes');

                    form.off().on('submit', function (e) {
                        e.preventDefault();

                        var formData = $(this).serialize();
                        var url = this.action;

                        $.ajax({
                            type: 'POST',
                            url: url,
                            data: formData,
                            success: function (response) {

                                if (!response.error) {
                                    modal.modal('hide');
                                    $(tableName).DataTable().ajax.reload(null, false);
                                }
                                printResponse(response);
                            },
                        })
                    });

                    modal.on('hidden.bs.modal', function () {
                        modal.remove();
                    });
                },
                error: fnToastrFormError
            });
        } else {
            $(modalName).remove();
        }
    });

    /**
     * Logic for showing decrypted value of new cpr number
     * The new value is always received encrypted directly from the database
     */
    $(document).off('click', '#show-new-cpr-number-button');
    $(document).on('click', '#show-new-cpr-number-button', function (e) {
        var employeeId = $(this).data('href');
        var $button = $(this);
        var $icon = $button.find('i');
        
        if ($icon.hasClass('fa-eye-slash')) {
            $icon.removeClass('fa-eye-slash').addClass('fa-eye');
        }

        $.ajax({
            url: '/employees/' + employeeId + '/salary/unmasked-social-security-number',
            method: 'GET',
            success: function (response) {
                $('input[name="[attributes][cpr][value]"]').val(response);
            }
        });
    });

    /**
     * Logic for showing decrypted value of old cpr number
     * The old value is always received encrypted from the request
     */
    $(document).off('click', '#show-old-cpr-number-button');
    $(document).on('click', '#show-old-cpr-number-button', function (e) {
      var $button = $(this);
      var $icon = $button.find('i');
      var employeeId = $(this).data('customer-employee');
      var oldValue = $(this).data('old-value');    

      if ($icon.hasClass('fa-eye-slash')) {
          $icon.removeClass('fa-eye-slash').addClass('fa-eye');
      } 
     
        $.ajax({
            url: '/employees/' + employeeId + '/salary/unmasked-social-security-number-from-encrypted-string',
            data: {
                encryptedValue: oldValue,
                employeeId: employeeId
            },
            method: 'GET',
            success: function (response) {
                 $('input[name="[old][cpr][value]"]').val(response);
            }
        });
    });
};